<template>
    <div>
        <menu-bar active="profile"></menu-bar>
        <div class="large-8 columns content__column">
            <h2 v-if="config.localeApp == 'se'">Rievdat beassansáni dahje e-poastačujuhusa</h2>
            <h2 v-else>Endre passord eller e-postadresse</h2>
            <p v-if="config.localeApp == 'se'">Vállje ođđa beassansáni dahje čále ođđa e-poastačujuhusa.</p>
            <p v-else>Velg deg et nytt passord eller skriv inn en ny e-postadresse.</p>

            <div class="form__errors" v-if="postErrors != null">
                <template v-if="config.localeApp == 'se'"
                    >Juoga ii doaimma.</template
                >
                <template v-else>
                    Det oppstod en feil.
                </template>
                <ul>
                    <template v-for="fieldErrors in postErrors">
                        <template v-for="error in fieldErrors">
                            <li>{{ error }}</li>
                        </template>
                    </template>
                </ul>
            </div>

            <div class="row form">
                <div class="form__field small-12 medium-7 columns">
                    <label class="form__label">
                        <template v-if="config.localeApp == 'se'">
                            Beassansátni</template
                        >
                        <template v-else
                            >Passord</template
                        >
                        <input
                            type="password"
                            name="password"
                            maxlength="255"
                            required
                            v-model="caller.password"
                            v-validate="'min:6'"
                            data-vv-as="Passord"
                            ref="password"
                        />
                        <span v-show="errors.has('password')" class="form__field__error">{{ errors.first('password') }}</span>
                    </label>
                </div>
                <div class="form__field small-12 medium-7 columns">
                    <label class="form__label">
                        <template v-if="config.localeApp == 'se'">
                            Gearddut beassansáni
                        </template>
                        <template v-else>
                            Gjenta passord
                        </template>
                        <input
                            type="password"
                            name="passwordConfirm"
                            maxlength="255"
                            required
                            v-model="passwordConfirm"
                            v-validate="'confirmed:password'"
                            data-vv-as="Passord"
                        />
                        <span v-show="errors.has('passwordConfirm')" class="form__field__error">{{ errors.first('passwordConfirm') }}</span>
                    </label>
                </div>
                <div class="form__field small-12 medium-7 columns">
                    <label class="form__label">
                        <template v-if="config.localeApp == 'se'">
                            ŠLEAĐGABOASTAČUJUHUS
                        </template>
                        <template v-else>
                            E-postadresse </template
                        ><input type="text" name="email" maxlength="255" v-model="caller.email" v-validate="'min:6'" data-vv-as="E-postadresse" />
                        <span v-show="errors.has('email')" class="form__field__error">{{ errors.first('email') }}</span>
                    </label>
                </div>
                <p class="small-12 columns" v-if="config.localeApp == 'se'">
                    <strong>Fuom! Mii eat vástit du SOS-dieđáhusaid du šleađgaboastačujuhussii. </strong><br />
                    Don fertet čálihit iežat sis jus áiggut lohkat vástádusaid du SOS-dieđáhusaide.
                </p>
                <p v-else class="small-12 columns">
                    <strong>NB! Vi sender ikke svar på SOS-meldinger til din e-postadresse.</strong><br />
                    Du må logge deg inn hos oss for å lese svarene på SOS-meldingene dine.
                </p>
                <div v-if="config.localeApp != 'se'" class="form__submit small-12 medium-12 columns" style="display:flex;align-items:center;">
                    <button @click.prevent="profile" class="button form__submit__button">
                        <template v-if="config.localeApp == 'se'">
                            Sádde
                        </template>
                        <template v-else>
                            Endre
                        </template>
                    </button>
                    <a @click.prevent="deleteAccount" href="#" style="margin-left:2rem;margin-bottom:1rem;">Slett min brukerprofil og alle meldingene.</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { config } from '../../volunteer/config/config';
import MenuBar from './Menu.vue';

export default {
    data() {
        return {
            caller: {
                password: '',
                email: '',
            },
            passwordConfirm: '',
            postErrors: null,

            config: config,
        };
    },
    components: {
        MenuBar,
    },
    created() {
        var user = this.$auth.user();
        if (user) {
            this.caller.email = user.email;
        }
    },
    methods: {
        profile() {
            var _this = this;
            this.postErrors = null;
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    // update profile
                    _this
                        .$http({ method: 'post', url: '/caller/profile', data: _this.caller })
                        // success
                        .then(function(response) {
                            if (response && response.data) {
                                var user = _this.$auth.user();
                                user.email = _this.caller.email;
                                _this.$auth.user(user);

                                _this.$router.push('/');
                            }
                        })
                        // failed
                        .catch(function(error) {
                            // (error.response);
                            if (error.response && error.response.data) {
                                var data = error.response.data;
                                // console.log(data);
                                _this.postErrors = data;
                            }
                        });
                }
            });
        },

        deleteAccount: async function() {
            if (
                window.confirm(
                    'Er du sikker på at du vil slette brukerkontoen din og alle meldingene? Det er ikke mulig å  gjenopprette den og meldingene vil være tapt for alltid.'
                )
            ) {
                try {
                    const response = await this.$http.delete('/caller');
                    if (response.data && response.data.status == 'success') {
                        this.$auth.logout({
                            success() {},
                            error() {},
                        });
                        window.alert('Din brukerkontoen og alle meldingene dine er slettet.');
                        this.$router.push('/');
                    } else {
                        alert(response.data.error || 'Det oppstod en ukjent feil');
                    }
                } catch (e) {
                    alert('Det oppstod en ukjent feil');
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue